import React, { useEffect, useState,useRef } from "react";
import Scrollbars from "react-custom-scrollbars-2";
///import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "./sidebardata";
import { ChevronLeft, User, Grid, Layers, Bookmark, RefreshCw, Calendar, Clock, Activity, Sun,DollarSign, Camera,MapPin ,Layout , Box, Briefcase,Bell, FileText, Users, Award, TrendingUp, FileMinus, FilePlus, List, Settings, Clipboard, BarChart2,Home } from 'react-feather';


const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = { t: (key) => key }; // Returns the key itself as a fallback

  const [sidebarData, setSidebarData] = useState(SidebarData);
  const [isSideMenu, setIsSideMenu] = useState("employee-dashboard");

  const profileTabRef = useRef(null);

  useEffect(() => {
    // Trigger the click event when the component mounts
    if (profileTabRef.current) {
      profileTabRef.current.click();
    }
  }, []);


  useEffect(() => {
    const menuMapping = {
        '/employees': 'employee',
        '/departments': 'employee',
        '/designations': 'employee',
        '/profile': 'profile',
        '/leave-types': 'employee',
        '/holidays': 'employee',
        '/shift-list': 'employee',
        '/overtime': 'employee',
        '/announcements': 'employee',
        '/leaves-employee': 'leaves',
        '/adminleaves': 'leaves',
        '/leave-applications': 'leaves',
        '/leaves-balance': 'leaves',
        '/leave-settings': 'leaves',
        '/attendance-weekly': 'attendance',
        '/attendance-daily': 'attendance',
        '/adminattendance': 'attendance',
        '/attendance-employee': 'attendance',
        '/payroll-overview': 'payroll-overview',
        '/salary': 'payroll-overview',
        '/payroll-items': 'payroll-overview',
        '/run-payroll': 'payroll-overview',
        '/payroll-settings': 'payroll-overview',
        '/payroll-history': 'payroll-overview',
        '/payroll-reports': 'payroll-overview',
        
        
        '/devices': 'devices',
        '/deviceslog': 'devices',
        '/device-users': 'devices',
        
        '/manage-locations': 'company-settings',
        '/manage-locations': 'company-settings',


        

        '/reports': 'reports',
        '/settings': 'settings',
        // Add more routes as necessary
    };

    const matchedMenu = Object.keys(menuMapping).find(route => pathname.startsWith(route));

    if (matchedMenu) {
        toggleSidebar(menuMapping[matchedMenu]);
    } else {
        toggleSidebar('dashboard'); // Default menu if no match
    }
}, [pathname]);

  useEffect(() => {
    if (!isSideMenu) {
      toggleSidebar('employee-dashboard');
    }
  }, []);

  const expandSubMenus = (menu) => {
    const updatedAdminSidebar = sidebarData.map((section) => {
        const updatedSection = { ...section };
        updatedSection.menu = section.menu.map((menuItem) =>
            menu.menuValue !== menuItem.menuValue
                ? { ...menuItem, showSubRoute: false }
                : { ...menuItem, showSubRoute: true }
        );
        return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
};


  const toggleSidebar = (value) => {
    setIsSideMenu(value);
  };

  const isActive = (routes) => {
    return routes.some(route => pathname.includes(route));
  };

  return (
    <div className="sidebar">
      <div className="sidebar-inner slimscroll-" style={{ overflow: false }}>
        <div id="sidebar-menu" className="sidebar-menu">
          <nav className="greedys sidebar-horizantal" id="horizantal-sidebar">
            {/* Horizontal Sidebar content */}
          </nav>

          <Scrollbars
            autoHide={false}
            autoHideTimeout={1000}
            autoHideDuration={200}
            autoHeight
            autoHeightMin={0}
            autoHeightMax="100vh"
            thumbMinSize={30}
            universal={false}
            hideTracksWhenNotNeeded={true}
          >
            <ul className="sidebar-vertical" id="veritical-sidebar">
              {sidebarData.map((mainTittle, index) => (
                <>
                  <li className="menu-title" key={index + 1}>
                    <span>{t(mainTittle.tittle)}</span>
                  </li>
                  {mainTittle.menu.map((menu, menuIndex) => (
                    <>
                      {!menu.hasSubRoute ? (
                        <li key={menuIndex + 1}>
                          <Link
                            to={menu.route}
                            className={isActive([menu.route]) ? "active" : ""}
                          >
                            <i className={menu?.icon} />
                            <span>{t(menu.menuValue)}</span>
                          </Link>
                        </li>
                      ) : (
                        <li className="submenu">
                          <Link
                            to="#"
                            onClick={() => expandSubMenus(menu)}
                            className={menu.showSubRoute ? "subdrop" : ""}
                          >
                            <i className={menu?.icon} />
                            <span>{t(menu.menuValue)}</span>
                            <span className="menu-arrow" />
                          </Link>
                          <ul
                            style={{
                              display: menu.showSubRoute ? "block" : "none",
                            }}
                          >
                            {menu.subMenus.map((subMenus, subMenu) => (
                              <>
                                {subMenus?.showMenuRoute ? (
                                  <li key={subMenu + 1}>
                                    <Link
                                      to={subMenus.route}
                                      className={isActive([subMenus.route]) ? "active" : ""}
                                    >
                                      {t(subMenus.menuValue)}
                                      <span className="menu-arrow" />
                                    </Link>
                                    <ul
                                      style={{
                                        display: subMenus.showSubRoute ? "block" : "none",
                                      }}
                                    >
                                      {subMenus?.subMenusValues?.map((value, index) => (
                                        <li key={index}>
                                          <Link 
                                            to={value.route}
                                            className={isActive([value.route]) ? "active" : ""}
                                          >
                                            <span>{t(value.menuValue)}</span>
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                ) : (
                                  <li key={subMenu + 1}>
                                    <Link
                                      to={subMenus.route}
                                      className={isActive([subMenus.route]) ? "active" : ""}
                                    >
                                      {t(subMenus.menuValue)}
                                    </Link>
                                    <ul>
                                      {subMenus?.subMenusValues?.map((value, index) => (
                                        <li key={index}>
                                          <Link 
                                            to={value.route}
                                            className={isActive([value.route]) ? "active" : ""}
                                          >
                                            {t(value.menuValue)}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                )}
                              </>
                            ))}
                          </ul>
                        </li>
                      )}
                    </>
                  ))}
                </>
              ))}
            </ul>
          </Scrollbars>
        </div>
      </div>

      <div className="two-col-bar" id="two-col-bar">
        <div className="sidebar sidebar-twocol">
          <div className="sidebar-left slimscroll">
            <div
              className="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >  
              <Link
                className={`nav-link ${isActive(["/employee-dashboard"]) ? "active" : ""}`}
                title="Dashboard"
                onClick={() => toggleSidebar("dashboard")}
                to="/employee-dashboard"
              >
                <span className="material-icons-outlined">home</span>
                <small>Home</small>
              </Link>
              <Link
                className={`nav-link ${isActive(["/employees", "/departments","/designations","/profile","/leave-types","/holiday","/shift-list","/overtime"]) ? "active" : ""}`}
                title="Employees"
                onClick={() => toggleSidebar("employee")}
                to="/employees"
              >
                <span className="material-icons-outlined">business</span>
                <small>Organization</small>
              </Link>
              <Link
                className={`nav-link ${isActive(["/leaves-employee","/adminleaves","/leave-applications","/leaves-balance","leave-settings"]) ? "active" : ""}`}
                title="Leaves"
                onClick={() => toggleSidebar("leaves")}
                to="/leaves-employee"
              >
                <span className="material-icons-outlined">access_time</span>
                <small>Leaves</small>
              </Link>
              <Link
                className={`nav-link ${isActive(["/attendance-weekly","attendance-daily","adminattendance","attendance-employee"]) ? "active" : ""}`}
                title="Attendance"
                onClick={() => toggleSidebar("attendance")}
                to="/attendance-weekly"
              
              >
                <span className="material-icons-outlined">how_to_reg</span>
                <small>Attendance</small>
              </Link>

              <Link
                className={`nav-link ${isActive(["/devices","/deviceslogs","/users"]) ? "active" : ""}`}
                title="Apps"
                onClick={() => toggleSidebar("devices")}
                to="/devices"
              >
                <span className="material-icons-outlined">smartphone</span>
                <small>Devices</small>
              </Link>


              <Link
                className={`nav-link ${isActive(["/payroll"]) ? "active" : ""}`}
                title="Payroll"
                onClick={() => toggleSidebar("payroll-overview")}
                to="/payroll-overview"
              >
                <span className="material-icons-outlined">account_circle</span>
                <small>Payroll</small>
              </Link>

              
              <Link
                className={`nav-link ${isActive(["/reports"]) ? "active" : ""}`}
                title="Reports"
                onClick={() => toggleSidebar("reports")}
                to="#"
              >
                <span className="material-icons-outlined">report</span>
                <small>Reports</small>
              </Link>
              <Link
                className={`nav-link ${isActive(["/settings"]) ? "active" : ""}`}
                title="Settings"
                onClick={() => toggleSidebar("settings")}
                to="#"
              >
                <span className="material-icons-outlined">settings</span>
                <small>Settings</small>
              </Link>
              <Link
                className={`nav-link ${isActive(["/profile"]) ? "active" : ""}`}
                title="Profile"
                onClick={() => toggleSidebar("profile")}
                to="#"
              >
                <span className="material-icons-outlined">account_circle</span>
                <small>Profile</small>
              </Link>
              <Link
                className={`nav-link ${isActive(["/support"]) ? "active" : ""}`}
                title="Support"
                onClick={() => toggleSidebar("support")}
                to="#"
              >
                <span className="material-icons-outlined">help_outline</span>
                <small>Support</small>
              </Link>
              <Link
                className={`nav-link ${isActive(["/logout"]) ? "active" : ""}`}
                title="Logout"
                onClick={() => toggleSidebar("logout")}
                to="#"
              >
                <span className="material-icons-outlined">exit_to_app</span>
                <small>Logout</small>
              </Link>
            </div>
          </div>

          <div className="sidebar-right">
            <div className="tab-content-horizontal" id="v-pills-tabContent">

            {isSideMenu === "dashboard" && (
                <div className="tab-pane fade active show">
                  <div className="submenu-horizontal">
                    <ul>
                      <li><Link className={isActive(['/employee-dashboard']) ? "active" : ""} to="/employee-dashboard"><Home  size={16} style={{ marginRight: '4px' }} />My Dashboard</Link></li>
                
                    </ul>
                  </div>
                </div>
              )}

              {isSideMenu === "employee" && (
                <div className="tab-pane fade active show">
                  <div className="submenu-horizontal">
                    <ul>
                      <li><Link className={isActive(['/employees']) ? "active" : ""} to="/employees"><Users size={14} style={{ marginRight: '4px' }} />Employee Directory</Link></li>
                      <li><Link className={isActive(['/departments']) ? "active" : ""} to="/departments"><Briefcase size={14} style={{ marginRight: '4px' }}/>Departments</Link></li>
                      <li><Link className={isActive(['/designations']) ? "active" : ""} to="/designations"><Award size={14} style={{ marginRight: '4px' }}/> 
                      Designations</Link></li>
                      <li><Link className={isActive(['/leave-types']) ? "active" : ""} to="/leave-types"><Calendar size={14} style={{ marginRight: '4px' }}/>Leave Type</Link></li>
                      <li><Link className={isActive(['/holidays']) ? "active" : ""} to="/holidays">  <Sun size={14} style={{ marginRight: '4px' }}/>Holidays</Link></li>
                      <li><Link className={isActive(['/shift-list']) ? "active" : ""} to="/shift-list"><Clock size={14} style={{ marginRight: '4px' }}/>Shift</Link></li>
                      <li><Link className={isActive(['/overtime']) ? "active" : ""} to="/overtime"><TrendingUp size={14} style={{ marginRight: '4px' }}/>Overtime</Link></li>
                      <li><Link className={isActive(['/announcements']) ? "active" : ""} to="/announcements"><Bell size={14} style={{ marginRight: '4px' }}/>Announcements</Link></li>

                    </ul>
                  </div>
                </div>
              )}

        {isSideMenu === "leaves" && (
                        <div className="tab-pane fade active show">
                          <div className="submenu-horizontal">
                          <ul>
                            <li>
                              <Link className={isActive(['/leaves-employee']) ? "active" : ""} to="/leaves-employee">
                                <FileMinus size={16} className="icon-with-margin" /> My Leaves
                              </Link>
                            </li>
                            <li>
                              <Link className={isActive(['/adminleaves']) ? "active" : ""} to="/adminleaves">
                                <FilePlus size={16} className="icon-with-margin" /> Leave Admin
                              </Link>
                            </li>
                            <li>
                              <Link className={isActive(['/leave-applications']) ? "active" : ""} to="/leave-applications">
                                <List size={16} className="icon-with-margin" /> Leave Requests
                              </Link>
                            </li>
                            <li>
                              <Link className={isActive(['/leaves-balance']) ? "active" : ""} to="/leaves-balance">
                                <Activity size={16} className="icon-with-margin" /> Leave Balances
                              </Link>
                            </li>
                            <li>
                              <Link className={isActive(['/leave-settings']) ? "active" : ""} to="/leave-settings">
                                <Settings size={16} className="icon-with-margin" /> Settings
                              </Link>
                            </li>
                          </ul>

                          </div>
                        </div>
                      )}


{isSideMenu === "attendance" && (
                <div className="tab-pane fade active show">
                  <div className="submenu-horizontal">
           
                  <ul>
                    <li>
                      <Link className={isActive(['/attendance-weekly']) ? "active" : ""} to="/attendance-weekly">
                        <Clipboard size={16} className="icon-with-margin" /> My Attendance
                      </Link>
                    </li>
                    <li>
                      <Link className={isActive(['/attendance-daily']) ? "active" : ""} to="/attendance-daily">
                        <Calendar size={16} className="icon-with-margin" /> Daily Attendance
                      </Link>
                    </li>
                    <li>
                      <Link className={isActive(['/adminattendance']) ? "active" : ""} to="/adminattendance">
                        <BarChart2 size={16} className="icon-with-margin" /> Monthly Summary
                      </Link>
                    </li>
</ul>


                 
                  </div>
                </div>
              )}


{isSideMenu === "devices" && (
                <div className="tab-pane fade active show">
                  <div className="submenu-horizontal">
                    <ul>
                      <li><Link className={isActive(['/devices']) ? "active" : ""} to="/devices"><Camera size={14} style={{ marginRight: '4px' }} />Manage AI Devices</Link></li>
                      <li><Link className={isActive(['/deviceslog']) ? "active" : ""} to="/deviceslog"><FileText size={14} style={{ marginRight: '4px' }} />
                      Device Logs</Link></li>
                      <li><Link className={isActive(['/device-users']) ? "active" : ""} to="/device-users"><RefreshCw  size={14} style={{ marginRight: '4px' }} />
                      Synch Users</Link></li>
                    </ul>
                  </div>
                </div>
              )}
{isSideMenu === "company-settings" && (
                <div className="tab-pane fade active show">
                  <div className="submenu-horizontal">
                    <ul>
                      
                    <li><Link className={isActive(['/devices']) ? "active" : ""} to="/company-settings"><Home  size={14} style={{ marginRight: '4px' }} />My Dashboard</Link></li>

                      <li><Link className={isActive(['/manage-locations']) ? "active" : ""} to="/manage-locations"><MapPin  size={14} style={{ marginRight: '4px' }} />
                      Manage Locations</Link></li>
                      <li><Link className={isActive(['/devices']) ? "active" : ""} to="/company-settings"><Settings size={14} style={{ marginRight: '4px' }} />Orgnization Settings</Link></li>

                     
                    </ul>
                  </div>
                </div>
              )}

{isSideMenu === "payroll-overview" && (
  <div className="tab-pane fade active show">
    <div className="submenu-horizontal">
      <ul>
        <li>
        <Link className={isActive(['/payroll-overview']) ? "active" : ""} to="/payroll-overview">
            <Clipboard size={16} className="icon-with-margin" /> Payroll Overview
          </Link>
        </li>
        <li>
          <Link className={isActive(['/salary']) ? "active" : ""} to="/salary">
            ₹ Employee Salary
          </Link>
        </li>
        <li>
          <Link className={isActive(['/payroll-items']) ? "active" : ""} to="/payroll-items">
            <FileMinus size={16} className="icon-with-margin" /> Salary Heads
          </Link>
        </li>
        <li>
          <Link className={isActive(['/run-payroll']) ? "active" : ""} to="/run-payroll">
            <FileText size={16} className="icon-with-margin" /> Process Payroll
          </Link>
        </li>
        <li>
          <Link to="/payroll-history"  className={isActive(['/payroll-history']) ? "active" : ""} >
            <Users size={16} className="icon-with-margin" /> Payroll History
          </Link>
        </li>
        <li>
          <Link className={isActive(['/payroll-settings']) ? "active" : ""} to="/payroll-settings">
            <Settings size={16} className="icon-with-margin" /> Settings
          </Link>
        </li>
        <li>
          <Link to="/payroll-reports" className={isActive(['/payroll-reports']) ? "active" : ""} >
            <BarChart2 size={16} className="icon-with-margin" /> Reports
          </Link>
        </li>
      </ul>
    </div>
  </div>
)}

              {isSideMenu === "reports" && (
                <div className="tab-pane fade active show">
                  <div className="submenu-horizontal">
                    <ul>
                      <li><Link to="/employee-reports">Employee Reports</Link></li>
                      <li><Link to="/leave-reports">Leave Reports</Link></li>
                      <li><Link to="/attendance-reports">Attendance Reports</Link></li>
                      <li><Link to="/performance-reports">Performance Reports</Link></li>
                    </ul>
                  </div>
                </div>
              )}

              {isSideMenu === "settings" && (
                <div className="tab-pane fade active show">
                  <div className="submenu-horizontal">
                    <ul>
                      <li><Link to="/account-settings">Account Settings</Link></li>
                      <li><Link to="/privacy-settings">Privacy Settings</Link></li>
                      <li><Link to="/notification-settings">Notification Settings</Link></li>
                      <li><Link to="/theme-settings">Theme Settings</Link></li>
                    </ul>
                  </div>
                </div>
              )}

{isSideMenu === "profile" && (
  <div className="tab-pane fade active show">
    <div className="submenu-horizontal d-flex justify-content-between align-items-center">
      <ul>
        <li>
          <Link to="/employees">
            <ChevronLeft size={16} /> Employee Directory
          </Link>
        </li>
      </ul>
      <ul className="nav  nav-tabs-bottom">
        <li>
          <Link
            to="#emp_profile"
            data-bs-toggle="tab"
            aria-selected="true"
            class="active"    
            ref={profileTabRef}     
         >
            <User size={16} /> Personal Profile
          </Link>
        </li>
        <li>
          <Link
            to="#emp_details"
            data-bs-toggle="tab"
          >
            <Briefcase size={16} /> Employment Details
          </Link>
        </li>
        <li>
          <Link
            to="#emp_assets"
            data-bs-toggle="tab"
          >
                       <Box size={16} /> Assets
          </Link>
        </li>
      </ul>
    </div>
  </div>
)}



              {/* Repeat for other main menu items like "leaves", "attendance", etc., ensuring each sub-menu uses the isActive check for proper highlighting */}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
